/* -- Announcement Bar: Pure Marquee v4 (full replacement) -- */
(function () {
  'use strict';

  var DONE_ATTR = 'data-tng-v4';
  var STYLE_ID  = 'tng-v4-kf';

  function buildTicker() {
    var comp = document.querySelector('announcement-bar-component');
    if (!comp) return false;
    if (comp.getAttribute(DONE_ATTR) === 'done') return true;

    var slideEls = comp.querySelectorAll('.announcement-bar__slide');
    if (!slideEls.length) return false;

    var texts = [];
    slideEls.forEach(function (el) {
      var raw = (typeof el.innerText !== 'undefined' ? el.innerText : el.textContent) || '';
      raw = raw.replace(/\s+/g, ' ').trim();
      if (raw) texts.push(raw);
    });

    if (!texts.length) return false;

    if (!document.getElementById(STYLE_ID)) {
      var kfStyle = document.createElement('style');
      kfStyle.id = STYLE_ID;
      kfStyle.textContent =
        '@keyframes tng-v4-scroll{' +
          '0%{transform:translateX(0)}' +
          '100%{transform:translateX(-50%)}' +
        '}';
      document.head.appendChild(kfStyle);
    }

    var SEPARATOR = '*';
    var dur = Math.max(14, texts.length * 6);

    function makeSet() {
      return texts.map(function (t) {
        return (
          '<span style="' +
            'display:inline-flex;align-items:center;' +
            'flex-shrink:0;white-space:nowrap;' +
            'padding:0 1.2rem;' +
          '">' +
            '<span style="opacity:.5;font-size:.55em;margin-right:1.2rem;" aria-hidden="true">' + SEPARATOR + '</span>' +
            t +
          '</span>'
        );
      }).join('');
    }

    var innerHTML =
      '<div id="tng-v4-inner" style="' +
        'display:flex;' +
        'flex-direction:row;' +
        'align-items:center;' +
        'width:max-content;' +
        'animation:tng-v4-scroll ' + dur + 's linear infinite;' +
        'will-change:transform;' +
      '">' +
        makeSet() + makeSet() +
      '</div>';

    comp.innerHTML = innerHTML;

    var existingStyle = comp.getAttribute('style') || '';
    comp.setAttribute('style',
      existingStyle +
      ';overflow:hidden!important' +
      ';display:flex!important' +
      ';align-items:center!important' +
      ';width:100%!important'
    );

    comp.addEventListener('mouseenter', function () {
      var inner = document.getElementById('tng-v4-inner');
      if (inner) inner.style.animationPlayState = 'paused';
    });
    comp.addEventListener('mouseleave', function () {
      var inner = document.getElementById('tng-v4-inner');
      if (inner) inner.style.animationPlayState = 'running';
    });

    comp.setAttribute(DONE_ATTR, 'done');
    return true;
  }

  var attempts = 0;
  function tryInit() {
    if (buildTicker()) return;
    if (++attempts < 40) setTimeout(tryInit, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(tryInit, 50); });
  } else {
    setTimeout(tryInit, 50);
  }

  window.addEventListener('load', function () { setTimeout(buildTicker, 200); });
})();


/* -- Native card price style fix -- */
(function () {
  'use strict';

  function injectPriceStyles() {
    var id = 'tng-price-styles';
    if (document.getElementById(id)) return;
    var s = document.createElement('style');
    s.id = id;
    s.textContent =
      'product-card span.price,' +
      'product-card .price-item__group.price{' +
        'color:#2A2FA3!important;' +
        'font-size:1.25rem!important;' +
        'font-weight:600!important;' +
        'display:block!important;' +
        'margin-top:6px!important;' +
        'font-family:var(--font-heading--family,inherit)!important;' +
      '}' +
      'product-card .compare-at-price{' +
        'font-size:0.85rem!important;' +
        'font-weight:400!important;' +
        'color:rgba(34,34,34,0.45)!important;' +
        'text-decoration:line-through!important;' +
      '}';
    document.head.appendChild(s);
  }

  function fixCurrency(root) {
    var sel =
      'product-card span.price,' +
      'product-card .price-item__group.price,' +
      'product-card .price-item__group.compare-at-price';
    (root || document).querySelectorAll(sel).forEach(function (el) {
      el.childNodes.forEach(function (node) {
        if (node.nodeType === 3) {
          node.textContent = node.textContent.replace(/LE\s+/g, 'EGP ');
        }
      });
    });
  }

  function init() {
    injectPriceStyles();
    fixCurrency();
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) fixCurrency(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
